import { JSX } from 'preact'
import classnames from 'classnames'
import { Overlay as IOverlay } from '@gsc/types'
import { previewProps } from '../../preview'
import { useComponentStyle } from '../Style'
import { useActions } from '../useActions'
import { shouldIgnoreEvents } from '../../helpers/events'

interface Props extends JSX.HTMLAttributes<HTMLDivElement> {
  overlay: IOverlay
}

export function Overlay({ overlay = {}, ...rest }: Props): JSX.Element {
  const { classes } = useComponentStyle('overlay', overlay)
  const processActions = useActions()

  const { actions = [] } = overlay

  const handleClick = async (e: MouseEvent) => {
    if (!actions.length || shouldIgnoreEvents(e.target as HTMLElement)) {
      return
    }

    e.preventDefault()
    e.stopPropagation()

    await processActions(actions, origin)
  }

  return <div className={classnames(classes)} onClick={handleClick} {...rest} {...previewProps('overlay')} />
}
